<template>
  <div class="box">
    <div class="option">
      <el-button size="small" icon="el-icon-plus" plain>新增分类</el-button>
      <div class="search">
        <el-input size="small" placeholder="请输入标签名称"></el-input>
        <el-button size="small">搜索</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="date" label="分类名称"> </el-table-column>
      <el-table-column prop="name" label="主题色"> </el-table-column>
      <el-table-column prop="address" label="人群包数量"> </el-table-column>
      <el-table-column prop="address" label="操作"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { listTag, delTag, listCommonTag, updateTag } from "@/api/market";
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      tableData: []
    };
  },
  mounted() {
    if (this.$route.query.jude) {
      this.is_status = this.$route.query.jude;
    }
    this.getList();
  },
  methods: {
    addSlice(index, edit = 0) {
      this.$router.push({
        path: `adSign?jude=${index}`
      });
      if (edit != 0) {
        localStorage.setItem("editCommon", edit);
      }
    },
    // 分頁
    handleCurrentChange(val) {
      console.log("val", val);
    },
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      listTag(data).then(res => {
        if (res.code == 200) {
          this.tableList = res.data;
        } else {
          this.$message.waring(res.msg);
        }
        console.log("标签列表", res);
      });
      listCommonTag(data).then(res => {
        if (res.code == 200) {
          this.CommonList = res.data;
        } else {
          this.$message.waring(res.msg);
        }
        console.log("手动标签列表", res);
      });
    },
    del(judes, id) {
      console.log("删除", id);
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      };
      delTag(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.reload();
          this.is_status = judes;
        } else {
          this.$message.waring(res.msg);
        }
      });
    },
    go(jude, id) {
      this.$router.push({
        path: `SignDetails?id=${id}`
      });
      localStorage.setItem("signDetailsJude", jude);
    },
    // updateTag
    manualUpdateTag(id) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      };
      updateTag(data).then(res => {
        this.$message(res.msg);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  background: #f2f2f6;
  border-radius: 6px;
  padding: 10px;
}
.option {
  width: 100%;
  padding: 10px 20px;
  background-color: #fff !important;
  color: #595961;
  height: 50px;
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  .search {
    width: 345px;
    display: flex;
  }
}
.flex {
  display: flex;
  justify-content: space-between;
}
</style>
